import {UnitsType} from "../types/UnitsType";
import {shortenBigNumbers} from "./shorten_big_numbers";

export const getLabelFromExtremum = (labelType: UnitsType, value: number) => {
    let label = "";
    switch (labelType) {
        case UnitsType.PERCENTS:
            label = `${value}%`;
            break;
        case UnitsType.YEARS:
            label = `${value} lat`;
            break;
        case UnitsType.NUMBERS:
        default:
            label = `${shortenBigNumbers(value)}`;
            break;
    }

    return label;
};
import {UnitsType} from "../types/UnitsType";
import {shortenBigNumbers} from "./shorten_big_numbers";

export const getLabelFromExtremum = (labelType: UnitsType, value: number) => {
    let label = "";
    switch (labelType) {
        case UnitsType.PERCENTS:
            label = `${value}%`;
            break;
        case UnitsType.YEARS:
            label = `${value} lat`;
            break;
        case UnitsType.NUMBERS:
        default:
            label = `${shortenBigNumbers(value)}`;
            break;
    }

    return label;
};
